import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetUploadItemsFromExcelResultQueryResponse, GetUploadItemsFromExcelResultQueryParams } from "../../types/GetUploadItemsFromExcelResult";

/**
     * @link /api/purchase-tenders/private/v1/item/view_parse-file-result
     */
export async function getUploadItemsFromExcelResult (params: GetUploadItemsFromExcelResultQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetUploadItemsFromExcelResultQueryResponse>["data"]> {
    const { data: resData } = await client<GetUploadItemsFromExcelResultQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/private/v1/item/view_parse-file-result`,
        params,
        ...options
    });
    
    return resData;
};